// extracted by mini-css-extract-plugin
export default {"container":"badges_container__sNrMO","titleWrap":"badges_titleWrap__dPcMO","badgesWrap":"badges_badgesWrap__NfCaF","overlay":"badges_overlay__hQgs2"};